// Renaming and reexporting `_FloatingMenuProps` to work around TS issues.
export { FloatingMenu } from './FloatingMenu';
export type { Props as FloatingMenuProps } from './FloatingMenu';
export type { FloatingMenuItem, FloatingMenuGetLabelForItem } from './types';
